// extracted by mini-css-extract-plugin
export default {"container":"tile_container__X5vlW","image":"tile_image__o+wP0","heading":"tile_heading__WBp8A","description":"tile_description__k6ds4"};